import { derived, writable } from 'svelte/store';
export class StateManager {
    constructor(s) {
        this._state = s;
        this._writableState = writable(s);
        this._readableState = derived(this._writableState, s => s);
    }
    get state() {
        return this._readableState;
    }
    setState(s) {
        this._state = s;
        this._writableState.set(s);
    }
    pathState(s) {
        const newState = Object.assign(Object.assign({}, this._state), s);
        this.setState(newState);
    }
}
